import styles from './PurchaseTokensMessage.module.css'

interface IPurchaseTokensMessage {
    showTokenPurchaseFlow: () => void
}

const PurchaseTokensMessage = ({ showTokenPurchaseFlow }: IPurchaseTokensMessage) => {
    return (
        <p className={styles.messageText}>
            You don’t have enough tokens for this option. 
            <br/>
            Purchase more{' '} <a className={styles.purchaseButton} onClick={showTokenPurchaseFlow}> here </a>
        </p>
    )
}

export default PurchaseTokensMessage